/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ " and ": NonNullable<unknown>, " et ": NonNullable<unknown> }} Remove_Text_Curly_BracesInputs */



/**
* | output |
* | --- |
* | "Remove text between { and }" |
*
* @param {Remove_Text_Curly_BracesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_text_curly_braces = /** @type {((inputs: Remove_Text_Curly_BracesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Text_Curly_BracesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer le texte entre ${i?.[" et "]}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Entferne den Text zwischen ${i?.[" and "]}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovi il testo tra ${i?.[" and "]}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалите текст между ${i?.[" and "]}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Eliminar texto entre ${i?.[" and "]}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除 ${i?.[" and "]} 之间的文本`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.[" and "]} 間のテキストを削除`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.[" and "]} के बीच का टेक्स्ट हटाएँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remover texto entre ${i?.[" and "]}`)
	return /** @type {LocalizedString} */ (`Remove text between ${i?.[" and "]}`)
});